/**
 * common.js
 *
 * @description Contains the logic that is common to all inputs.
 * Adopters can override all or some of this.
 *
 */
import { OwalInputType } from '../inputType'

export const Input = {
  props: {
    /**
     * @prop type The type of input.
     */
    type: {
      type: String,
      default: OwalInputType.rawValue(OwalInputType.TEXT),
    },
    /**
     * @prop type The input's identifier.
     */
    identifier: {
      type: String,
      required: true,
      default: undefined,
    },
    /**
     * @prop An initial value.
     */
    initialValue: {
      type: undefined,
      required: false,
    },
    /**
     * @prop Controls field layout.
     */
    inline: {
      type: Boolean,
      default: false,
    },
    /**
     * The label shown in UI.
     */
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * @prop The name of the data used in the upload to the server.
     */
    name: {
      type: String,
      default: undefined,
      required: false,
    },
    /**
     * @prop A placeholder for the input.
     * @description For text based fields, the placeholder will be displayed.\
     * For image inputs, this should be a URL to a placeholder.
     */
    placeholder: {
      type: String,
      default: undefined,
      required: false,
    },
    /**
     * @prop Is the field required?
     */
    required: {
      type: Boolean,
      default: false,
    },
  },
  created () {
    this.applyInitialValue()
  },
  data () {
    return {
      value: this.initialValue,
    }
  },
  methods: {
    /**
     * Sets the value for the input.
     * @property {Any} value The value of the field.
     */
    setValue: function (value) {
      this.value = value
      this.emitChange(value)
    },
    /** Emits a change event. */
    emitChange (value) {
      const identifier = this.identifier
      /**
       * Note: There are multiple emits here. This is intentional.
       * In order to support to v-model, we need to emit an 'input' event.
       * We emit the change event for backwards compatibility.
       */
      this.$emit('change', { value, identifier })
      this.$emit('input', value)
      this.$emit('update:value', value)
    },
    /** Emits a blur event. */
    emitBlur () {
      this.$emit('blur')
    },
    /**
     * Sets the value to the initial value, if there is one supplied.
     */
    applyInitialValue () {
      if (this.initialValue) {
        this.setValue(this.initialValue)
      }
    },
  },
}
